import { init, simulator } from '@nemuru-eng/checkout-js';
import { Agent, Branding, CustomTheme, getLocaleByPurchaseCountry } from '@nemuru-eng/js-api-client';

import { ENV_ENV } from '@/config/envVars';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useUser } from '@/hooks/useUser';

type SimulatorProps = Parameters<typeof simulator>[0];
type SimulatorOptions = SimulatorProps['options'];
type SimulatorComponentProps = Omit<SimulatorProps, 'agentId' | 'options'> & { options?: Partial<SimulatorOptions> };

export const useSimulator = () => {
  const { userEntity } = useUser();
  const { themeName } = useCustomTheme();
  const {
    state: { darkMode },
  } = useConfigContext();

  const simulatorComponent = async (data: SimulatorComponentProps, agent?: Agent) => {
    if (themeName === 'neutral') return;
    const simulatorAgent = agent || userEntity?.agent;
    if (!simulatorAgent?.id) return;
    await init(simulatorAgent.id, {
      env: ENV_ENV,
      locale: getLocaleByPurchaseCountry(simulatorAgent.allowedPurchaseCountries[0]),
    });
    return simulator({
      agentId: simulatorAgent.id,
      options: {
        ...data.options,
        locale: 'es-ES',
        branding: themeToBranding(themeName as CustomTheme),
        colorMode: darkMode ? 'dark' : 'light',
        mode: 'embedded',
        disableLocaleSelector: true,
      },
      boundaries: data.boundaries,
      onSelected: data.onSelected,
      onError: data.onError,
    });
  };

  return { simulatorComponent };
};

const themeToBranding = (themeName: CustomTheme): Branding => {
  if (themeName === CustomTheme.IBERIA) return Branding.IBERIA;
  if (themeName === CustomTheme.CAIXABANK) return Branding.CAIXABANK;
  if (themeName === CustomTheme.QUADIS) return Branding.QUADIS;
  if (themeName === CustomTheme.NEMURU) return Branding.NEMURU;
  if (themeName === CustomTheme.KTUIN) return Branding.KTUIN;
  return Branding.DEFAULT;
};
